module.exports = __webpack_public_path__ + "img/xiaochengxu.a9dcc04e.jpg";